<template>
  <div>首页</div>
</template>

<script>
export default {
  name: "SassIndex",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
